import {Component, OnDestroy, OnInit, Renderer2, ChangeDetectionStrategy} from '@angular/core';
import {SettingsService} from '../../core/settings/settings.service';
import {ThemesService} from '../../core/themes/themes.service';
import {TranslatorService} from '../../core/translator/translator.service';

@Component({
    selector: 'app-offsidebar',
    templateUrl: './offsidebar.component.html',
    styleUrls: ['./offsidebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class OffsidebarComponent implements OnInit, OnDestroy {

  currentTheme: any;
  selectedLanguage: string;
  private unlistenDocClick: (() => void) | null = null;

  constructor(public settings: SettingsService,
              public themes: ThemesService,
              public translator: TranslatorService,
              private renderer: Renderer2) {
    this.currentTheme = themes.getDefaultTheme();
    this.selectedLanguage = this.getLangs()[1].code;
  }

  ngOnInit() {
    this.anyClickClose();
  }

  setTheme() {
    this.themes.setTheme(this.currentTheme);
  }

  getLangs() {
    return this.translator.getAvailableLanguages();
  }

  setLang(value) {
    this.translator.useLanguage(value);
  }

  anyClickClose() {
    this.unlistenDocClick = this.renderer.listen('document', 'click', (e: Event) => {
      const target = e.target as HTMLElement;
      if (target && !target.closest('.offsidebar')) {
        this.settings.layout.offsidebarOpen = false;
      }
    });
  }

  ngOnDestroy() {
    if (this.unlistenDocClick) {
      this.unlistenDocClick();
    }
  }
}
